export default __webpack_public_path__ + "static/media/particleNoteSecondary.b7d436c8.svg";